import React, { useContext, useState, useEffect } from 'react';
import YesNo from '../../../../../../components/Dialog/YesNo';
import { store } from '../Fleets';
import TextField from '@material-ui/core/TextField';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import { makeStyles } from '@material-ui/core/styles';
import axios from '../../../../../../api/axios';
import { store as store2 } from '../../../../../../store';
import FormHelperText from '@material-ui/core/FormHelperText';
import { CircularProgress } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  form: {
    display: 'flex',
    flexDirection: 'column',
    '& > div': {
      marginBottom: theme.spacing(1),
    },
  },
  percent: {
    width: '250px',
  },
  percentTitle: {
    fontWeight: 'bold',
    fontSize: 40,
    marginLeft: theme.spacing(1),
  },
  helper: {
    color: theme.palette.error.light,
    marginBottom: theme.spacing(1),
  },
}));

const AddFleetOptionDialog = ({ f }) => {
  const classes = useStyles();
  const { state, dispatch, getFleetsAndFleetOptions } = useContext(store);
  const { showMessage, showError } = useContext(store2);
  const [fleetOption, setFleetOption] = useState({});
  const [error, setError] = useState({});
  const mode = typeof f === 'object' ? 'edit' : 'new';
  const [loading, setLoading] = useState(false);

  const verify = () => {
    let err = {};
    if (!fleetOption.title) {
      err.title = 'عنوان را وارد نمائید.';
    }
    if (!fleetOption.fleet) {
      err.fleet = 'یک ناوگان انتخاب کنید.';
    }

    return err;
  };
  const handleClose = async (agree) => {
    if (agree) {
      let err = verify();
      if (Object.entries(err).length) {
        setError(err);
        showError('خطا در هنگام ثبت.');
        return;
      }
      try {
        setLoading(true);
        await axios.post(
          `/api/v1/admin/parameters/fleets/fleetOption`,
          fleetOption
        );
        showMessage('ویژگی ناوگان با موفقیت اضافه گردید.');
        getFleetsAndFleetOptions();
      } catch (error) {
        console.error(JSON.stringify(error, null, 2));
      }
      setLoading(false);
      dispatch({ type: 'CLOSE_ADD_FLEET_OPTIONS_DIALOG' });
    } else dispatch({ type: 'CLOSE_ADD_FLEET_OPTIONS_DIALOG' });
  };
  const handleChangeTextField = (e) => {
    const { value, name } = e.target;
    setFleetOption({ ...fleetOption, [name]: value });
  };
  const handleChangeToggle = (e, value) => {
    setFleetOption({ ...fleetOption, fleet: value });
  };

  useEffect(() => {
    if (mode === 'edit') {
      setFleetOption(f);
    }
  }, [mode]);

  return (
    <YesNo
      fullWidth
      title={mode === 'edit' ? `ویرایش ویژگی ناوگان` : 'ویژگی ناوگان جدید'}
      yes={mode === 'edit' ? 'ویرایش' : 'افزودن'}
      no="صرفنظر"
      onClose={handleClose}
      inProgress={loading}
      endIcon={loading ? <CircularProgress size={10} /> : <></>}
      loadingButton
    >
      <div className={classes.form}>
        <TextField
          name="title"
          variant="outlined"
          size="medium"
          label="عنوان ویژگی ناوگان"
          fullWidth
          onChange={handleChangeTextField}
          value={fleetOption.title ? fleetOption.title : ''}
          error={error.title ? true : false}
          helperText={error.title ? error.title : ''}
        />
        <ToggleButtonGroup
          value={
            fleetOption.fleet
              ? typeof fleetOption.fleet === 'object'
                ? fleetOption.fleet._id
                : fleetOption.fleet
              : null
          }
          exclusive
          onChange={handleChangeToggle}
          style={{ width: '100%' }}
        >
          {state.fleets.map((fl) => (
            <ToggleButton key={fl._id} value={fl._id}>
              {fl.title}
            </ToggleButton>
          ))}
          {/* <ToggleButton value="Kg" style={{ width: '50%' }}>
            کیلوگرم
          </ToggleButton> */}
          {error.fleet ? (
            <FormHelperText className={classes.helper}>
              {error.fleet}
            </FormHelperText>
          ) : null}
        </ToggleButtonGroup>

        <div>
          <TextField
            type="number"
            error={error.effectivePercentage ? true : false}
            name="effectivePercentage"
            value={
              fleetOption.effectivePercentage
                ? fleetOption.effectivePercentage
                : ''
            }
            onChange={handleChangeTextField}
            fullWidth
            label="درصد موثر"
            variant="outlined"
            size="medium"
            className={classes.percent}
          />
          <span className={classes.percentTitle}>%</span>
        </div>
      </div>
    </YesNo>
  );
};

export default AddFleetOptionDialog;
